import Vue from "vue";
import Router from "vue-router";
// import { accessConstants } from "@/shared/accessConstants";
import { logValuesInSession, checkAccessControl } from "@/shared/utils";
//layout
const RootSidebarContainer = () => import("@/containers/RootSidebarContainer");
const DefaultContainer = () => import("@/containers/DefaultContainer");

//user login
const UserLogin = () => import("@/views/user/auth/UserLogin");
const UserResetPasswordRequest = () =>
  import("@/views/user/auth/UserResetPasswordRequest");
const UserResetPassword = () => import("@/views/user/auth/UserResetPassword");

//user pages
const UserDashboard = () => import("@/views/business/dashboard/Index");
const ImprovementExpense = () =>
  import("@/views/business/dashboard/ImprovementExpense");
const ImprovementExpenseMonth = () =>
  import("@/views/business/dashboard/ImprovementExpenseMonth");

const ReductionProposal = () =>
  import("@/views/business/proposal/ReductionProposal");
const InputExpenseItem = () =>
  import("@/views/business/expenseItem/InputExpenseItem");

const ProposalMessage = () =>
  import("@/views/business/proposal/ProposalMessage");

const ExpenseEvaluationList = () =>
  import("@/views/business/expenseDetails/ExpenseEvaluationList");
const MonthlyExpenseDetails = () =>
  import("@/views/business/expenseDetails/MonthlyExpenseDetails");
const YearlyExpenseDetails = () =>
  import("@/views/business/expenseDetails/YearlyExpenseDetails");
const ExpenseConfirmation = () =>
  import("@/views/business/expenseConfirmation/ExpenseConfirmation");
const ReductionProposalPreview = () =>
  import("@/views/business/reductionPreview/ReductionProposalPreview");
const Settings = () => import("@/views/business/settings/Index");
const CreateClient = () => import("@/views/management/clientManagement/CreateClient");

const AgencyServiceRequest = () =>
  import("@/views/business/expenseItem/AgencyServiceRequest");

const AccountItemConfirmation = () =>
  import("@/views/management/officialAccount/ItemConfirmation");

//terms pages
const TermsOfService = () => import("@/views/business/termsOfService/Index");
const QAndA = () => import("@/views/business/qAndA/Index");
const PrivacyPolicy = () => import("@/views/business/privacyPolicy/Index");
const Inquiry = () => import("@/views/business/inquiry/Index");
const InquiryCompleted = () =>
  import("@/views/business/inquiry/InquiryCompleted");
const FAQ = () => import("@/views/business/faq/index");

//admin Pages
const TaskProcess = () => import("@/views/management/task/TaskProcess");
const TaskDetails = () => import("@/views/management/task/TaskDetails");
const TaskDetailsAgency = () =>
  import("@/views/management/task/TaskDetailsAgency");

const ExpenseItemAdd = () => import("@/views/management/expenseItem/AddEdit");
const TaskDetailsSubsidy = () =>
  import("@/views/management/task/TaskDetailsSubsidy");
const ClientProcess = () =>
  import("@/views/management/clientManagement/clientDetails");
const ClientList = () =>
  import("@/views/management/clientManagement/ClientList");
const SupplierList = () => import("@/views/management/supplier/SupplierList");
const UserManagement = () => import("@/views/management/UserManagement");
const UserManagementEditAdd = () =>
  import("@/views/management/UserManagementEditAdd");

const PersonInchargeList = () =>
  import("@/views/management/PersonIncharge/PersonInchargeList");
const MasterMaintenanceList = () =>
  import("@/views/management/MasterMaintenance/MasterMaintenanceList");

const NotFound = () => import("@/views/NotFound");
const InputExpenseItems = () =>
  import("@/components/settings/InputExpenseItems");

// 仕訳帳インポート
const JournalImport = () => import("@/views/business/Journal/JournalImport/JournalImport.vue");
const ItemConfirmation = () => import("@/views/business/Journal/ItemConfirmation/ItemConfirmation.vue");
const ExtractConfirmation = () => import("@/views/business/Journal/ExtractConfirmation/ExtractConfirmation.vue");
const CostItemBinding = () => import("@/views/business/Journal/CostItemBinding/CostItemBinding.vue");
const ExtractComplete = () => import("@/views/business/Journal/ExtractComplete/ExtractComplete.vue");
const FreeAPIAccesstokenFetch = () => import("@/views/business/Journal/FreeAPIAccesstokenFetch/FreeAPIAccesstokenFetch.vue");
const FileDownload = () => import("@/views/business/Journal/FileDownload/FileDownload.vue");
const FileDownloadComplete = () =>  import("@/views/business/Journal/FileDownloadComplete/FileDownloadComplete.vue");

// 担当者管理
const PersonMgmtAddEdit = () =>
  import("@/views/management/personManagement/AddEdit");

// 補助金・助成金交付判定
// CRF-56 選択内容確認
const ContentConfirmation = () =>
  import("@/views/business/subsidyGrantJudgement/ContentConfirmation");
const SubsidyGrantJudgement = () =>
  import("@/views/business/subsidyGrantJudgement/Index");
const JudgementChart = () =>
  import("@/views/business/subsidyGrantJudgement/JudgementChart");
const JudgementResult = () =>
  import("@/views/business/subsidyGrantJudgement/JudgementResult");

const SubsidyAppConfirmation = () =>
  import("@/views/business/subsidyApp/Confirmation");
const SubsidyAppComplete = () => import("@/views/business/subsidyApp/Complete");

// サプライヤー
const SupplierAddEdit = () => import("@/views/management/supplier/AddEdit");
const SupplierReductionProposalAddEdit = () =>
  import("@/views/management/supplier/ReductionProposalAddEdit");

// マスタメンテ
const MasterMaintenance = () =>
  import("@/views/management/settings/Maintenance");

// 顧客管理
// const ClientMgmt = () => import("@/views/management/clientManagement/Index");
const CostReductionProposal = () =>
  import("@/views/management/clientManagement/CostReductionProposal");
const RequestAppDetail = () =>
  import("@/views/management/clientManagement/RequestAppDetail");
const ContractInfoAddEdit = () =>
  import("@/views/management/clientManagement/ContractInfoAddEdit");
// CRF-52 補助金査定メッセージ詳細
const SubsidyAssessMsgDetail = () =>
  import("@/views/business/notification/SubsidyAssessMsgDetail");
// CRM-40 勘定科目マスタメンテ
const CostAccountMaintenance = () =>
  import("@/views/management/settings/CostAccountMaintenance");
// CRM-41 勘定科目マスタ登録・編集
const CostAccountMaintenanceAddEdit = () =>
  import("@/views/management/settings/CostAccountMaintenanceAddEdit");
const SupplierCompany = () =>
  import("@/views/management/settings/SupplierCompany");
const SupplierCompanyUpdate = () =>
  import("@/views/management/settings/SupplierCompanyUpdate");
const SupplierCompanyImport = () =>
  import("@/views/management/settings/SupplierCompanyImport");
const JournalFormat = () =>
  import("@/views/management/settings/JournalFormat");
const JournalFormatUpdate = () =>
  import("@/views/management/settings/JournalFormatUpdate");
// CRM-15 顧客一覧
// CRM-58 削除提案条件検索(モーダル)
const Clientlists = () => import("@/views/management/clientlist/Index");
const ClientTransactionAdd = () =>
  import("@/views/management/clientManagement/ClientTransactionAdd");
// CRM-85 費目別評価・判定設定（年）
const JudgementSettingYear = () =>
  import("@/views/management/settings/JudgementSettingYear");
// CRM-85 費目別評価・判定設定（年）updated on 9th mar 2021
const JudgementSettingYearUpdate = () =>
import("@/views/management/settings/JudgementSettingYearUpdate");
// CRM-86 費目別評価・判定設定（月）
const JudgementSettingMonth = () =>
  import("@/views/management/settings/JudgementSettingMonth");
// CRM-98 補助金情報編集
const SubsidyInfoEdit = () =>
  import("@/views/management/clientManagement/SubsidyInfoEdit");
// CRM-99 補助金査定詳細
const SubsidyAssessmentDetail = () =>
  import("@/views/management/clientManagement/SubsidyAssessmentDetail");
// CRF-42 ポイントプログラム
const PointProgram = () => import("@/views/business/pointProgram/Index");
// CRF-43 ポイント獲得・消費履歴
const PointProgramHistory = () =>
  import("@/views/business/pointProgram/History");
// CRF-44 ポイント交換応募確認
const PointProgramPointExchangeConfirmation = () =>
  import("@/views/business/pointProgram/PointExchangeConfirmation");
// CRF-45 ポイント交換応募完了
const PointProgramPointExchangeComplete = () =>
  import("@/views/business/pointProgram/PointExchangeComplete");
// CRF-51 ポイント交換応募一覧
// CRF-50 ポイント説明(モーダル画面)
const PointProgramPointExchangeAppList = () =>
  import("@/views/business/pointProgram/PointProgramPointExchangeAppList");
//CRM-92
const SubsidyAssessment = () =>
  import("@/views/management/clientManagement/SubsidyAssesMent");

// CRM-47 ポイントプログラム
const PointProgramAdmin = () =>
  import("@/views/management/pointProgram/IndexAdmin");
// CRM-48 カテゴリ登録・編集
const CategoryAddEdit = () =>
  import("@/views/management/pointProgram/CategoryAddEdit");
// CRM-95 カテゴリ登録編集確認
const CategoryAddEditConfirmation = () =>
  import("@/views/management/pointProgram/CategoryAddEditConfirmation");
// CRM-96 カテゴリ登録編集完了
const CategoryAddEditComplete = () =>
  import("@/views/management/pointProgram/CategoryAddEditComplete");

// CRM-49 ポイントプログラム登録・編集
const ProgramAddEdit = () =>
  import("@/views/management/pointProgram/ProgramAddEdit");
// CRM-50 ポイントプログラム登録編集確認
const ProgramAddEditConfirmation = () =>
  import("@/views/management/pointProgram/ProgramAddEditConfirmation");
// CRM-51 ポイントプログラム登録編集完了
const ProgramAddEditComplete = () =>
  import("@/views/management/pointProgram/ProgramAddEditComplete");
// CRM-53 サプライヤー別契約一覧
const SupplierContractList = () =>
  import("@/views/management/statisticalDataRoom/SupplierContractList");
// CRM-87 サプライヤー別契約獲得数一覧
const SupplierAcquisitionList = () =>
  import("@/views/management/statisticalDataRoom/SupplierAcquisitionList");
// CRM-54 費目別契約一覧
const CostItemWiseContractList = () =>
  import("@/views/management/statisticalDataRoom/CostItemWiseContractList");
// CRM-88 費目別契約獲得数一覧
const CostItemContractList = () =>
  import("@/views/management/statisticalDataRoom/CostItemContractList");
// CRM-56 担当者別契約一覧
const PersonWiseContractList = () =>
  import("@/views/management/statisticalDataRoom/PersonWiseContractList");
// CRM-90 担当別契約獲得数一覧
const PersonContractList = () =>
  import("@/views/management/statisticalDataRoom/PersonContractList");

// CRM-52 統計データルーム
const StatisticalDataRoom = () =>
  import("@/views/management/statisticalDataRoom/Index");
// CRM-57 システムマスタメンテナンス
const SystemMasterMaintenance = () =>
  import("@/views/management/settings/SystemMasterMaintenance");
// CRM-79 業種分類マスタメンテナンス
const IndustryTypeMaintenance = () =>
  import("@/views/management/settings/IndustryTypeMaintenance");
// CRM-80 契約ステータスマスタメンテナンス
const ContractStatusMaintenance = () =>
  import("@/views/management/settings/ContractStatusMaintenance");
// CRM-93 業種分類マスタ登録・編集
const IndustryTypeAddEdit = () =>
  import("@/views/management/settings/IndustryTypeAddEdit");
// CRM-94 契約ステータスマスタ登録・編集
const ContractStatusAddEdit = () =>
  import("@/views/management/settings/ContractStatusAddEdit");

//DUPLICATE COMPONENTS
const TaskSubsidyAssessmentDetail = () =>
  import("@/views/management/clientManagement/SubsidyAssessmentDetail");
const TaskInputExpenseItems = () =>
  import("@/components/settings/InputExpenseItems");
const TaskClientProcess = () =>
  import("@/views/management/clientManagement/clientDetails");
const UserInputExpenseItem = () =>
  import("@/views/business/expenseItem/InputExpenseItem");

Vue.use(Router);

// eslint-disable-next-line no-unused-vars
const adminRoutes = [
  { path: "/404", component: NotFound },
  { path: "*", redirect: "/404" },
  { path: "/", redirect: { name: "admin_login" } },
  {
    path: "/",
    component: DefaultContainer,
    children: [
      {
        path: "qna",
        name: "q_and_a",
        component: QAndA,
        meta: {
          title: "KANBEI",
        },
      },
      {
        path: "contact",
        name: "inquiry",
        component: Inquiry,
        meta: {
          title: "KANBEI",
        },
      },
      {
        path: "privacy_policy",
        name: "privacyPolicy",
        component: PrivacyPolicy,
        meta: {
          title: "KANBEI",
        },
      },
      {
        path: "contact/complete",
        name: "contact_complete",
        component: InquiryCompleted,
        meta: {
          title: "KANBEI",
        },
      },
    ],
  },
  {
    path: "/login",
    name: "admin_login",
    component: UserLogin,
    meta: { breadcrumb: "SCHEDULE", title: "KANBEI" },
  },
  {
    path: "/reset/password/request",
    name: "admin_reset_password_request",
    component: UserResetPasswordRequest,
    meta: { breadcrumb: "SCHEDULE", title: "KANBEI" },
  },
  {
    path: "/reset/password/:token",
    name: "admin_reset_password",
    component: UserResetPassword,
    meta: { breadcrumb: "SCHEDULE", title: "KANBEI" },
  },

  {
    path: "/",
    component: RootSidebarContainer,
    children: [
      {
        path: "dashboard",
        name: "admin_dasboard",
        component: TaskProcess,
        meta: {
          breadcrumb: [{ name: "TASKPROCESS" }],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      //CRM-11
      {
        path: "tasks/details",
        name: "task_details",
        component: TaskDetails,
        meta: {
          breadcrumb: [
            { name: "TASKPROCESS", link: "/dashboard" },
            { name: "TASKDETAILS" },
          ],
          access_key: "task-detail-cost-reduction-crm-11",
          auth: true,
          admin: true,
        },
      },
      //CRM-21
      {
        path: "supplier",
        name: "supplier_list",
        component: SupplierList,
        meta: {
          breadcrumb: [{ name: "SUPPLIER" }],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      //CRM-34
      {
        path: "personIncharge",
        name: "personincharge_list",
        component: PersonInchargeList,
        meta: {
          breadcrumb: [{ name: "PERSONMGMT" }],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      //CRM-42
      {
        path: "mastermaintenance",
        name: "mastermaintenance_list",
        component: MasterMaintenanceList,
        meta: {
          breadcrumb: [
            { name: "MASTERMAINTENANCETITLE", link: "/master/maintenance" },
            { name: "ITEMMASTERMAINTENANCE" },
          ],
          access_key: "expense-item-master-maintenance-crm-42",
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      //CRM-16
      {
        path: "clientProcess",
        name: "client_process",
        component: ClientProcess,
        meta: {
          breadcrumb: [{ name: "CLIENTPROCESS" }],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      //CRM-15
      {
        path: "client/list",
        name: "client_list",
        component: ClientList,
        meta: {
          breadcrumb: [{ name: "CUSTOMETLIST" }],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      //CreateClient
      {
        path: "client/createClient",
        name: "create_client",
        component: CreateClient,
        meta: {
          breadcrumb: [
            { name: "CUSTOMETLIST", link:"/client/list" },
            { name: "CREATECLIENT" }
        ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },

      {
        path: "InputExpenseItems",
        name: "input_expense_items",
        component: InputExpenseItems,
        meta: {
          breadcrumb: [
            { name: "CLIENTPROCESS", link: "/clientProcess" },
            { name: "BYEXPENSEITEM" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      //CRM-13
      {
        path: "tasks/agencydetails",
        name: "task_agency_details",
        component: TaskDetailsAgency,
        meta: {
          breadcrumb: [
            { name: "TASKPROCESS", link: "/dashboard" },
            { name: "TASKDETAILSAGENCY" },
          ],
          title: "KANBEI",
          access_key: "task-detail-input-agency-crm-13",
          auth: true,
          admin: true,
        },
      },
      //CRM-43
      {
        path: "expenseitem/addedit",
        name: "expense_item_add_edit",
        component: ExpenseItemAdd,
        meta: {
          breadcrumb: [
            { name: "MASTERMAINTENANCETITLE", link: "/master/maintenance" },
            { name: "ITEMMASTERMAINTENANCE", link: "/mastermaintenance" },
            { name: "EXPENSEADD" },
          ],
          title: "KANBEI",
          access_key: "expense-item-master-add-edit-crm-43",
          auth: true,
          admin: true,
        },
      },
      //CRM-12
      {
        path: "tasks/subsidydetails/",
        name: "task_subsidy_details",
        component: TaskDetailsSubsidy,
        meta: {
          breadcrumb: [
            { name: "TASKPROCESS", link: "/dashboard" },
            { name: "TASKDETAILSUBSIDY" },
          ],
          title: "KANBEI",
          access_key: "task-detail-subsidy-crm-12",
          auth: true,
          admin: true,
        },
      },
      //CRM-28
      {
        path: "usermanagement",
        name: "user_management",
        component: UserManagement,
        meta: {
          breadcrumb: [{ name: "USERMANAGEMENT.USERMANAGEMENT" }],
          title: "KANBEI",
          access_key: "user-management-crm-28",
          auth: true,
          admin: true,
        },
      },
      //CRM-29
      {
        path: "usermanagement/edit/:userData?",
        name: "user_management_edit_add",
        component: UserManagementEditAdd,
        meta: {
          breadcrumb: [
            {
              name: "USERMANAGEMENT.USERMANAGEMENT",
              link: "/usermanagement",
            },
            { name: "USERMANAGEMENT.ADDEDIT" },
          ],
          title: "KANBEI",
          access_key: "user-management-add-edit-crm-29",
          auth: true,
          admin: true,
        },
      },
      //CRM 22
      {
        path: "supplier/addEdit",
        name: "supplier_addEdit",
        component: SupplierAddEdit,
        meta: {
          breadcrumb: [
            {
              name: "SUPPLIER",
              link: "/supplier",
            },
            { name: "SUPPLIERADDEDIT" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-23 削減提案登録・編集
      {
        path: "supplier/reduction/proposal/addEdit",
        name: "supplier_reduction_proposal_addEdit",
        component: SupplierReductionProposalAddEdit,
        meta: {
          breadcrumb: [
            {
              name: "SUPPLIER",
              link: "/supplier",
            },
            {
              name: "SUPPLIERADDEDIT",
              link: "/supplier/addEdit",
            },
            { name: "SUPPLIERREDUCTIONPROPOSALADDEDIT" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-35 担当者登録・編集（アカウント情報）
      // CRM-36 担当者登録・編集（担当者情報）
      {
        path: "personMgmt/addEdit:personData?",
        name: "personMgmt_addEdit",
        component: PersonMgmtAddEdit,
        meta: {
          breadcrumb: [
            {
              name: "PERSONMGMT",
              link: "/personIncharge",
            },
            { name: "PERSONMGMTADDEDIT" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-39 マスタメンテ
      {
        path: "master/maintenance",
        name: "master_maintenance",
        component: MasterMaintenance,
        meta: {
          breadcrumb: [{ name: "MASTERMAINTENANCETITLE" }],
          title: "KANBEI",
          access_key: "master-maintenance-crm-39",
          auth: true,
          admin: true,
        },
      },
      // CRM-70 経費削減提案
      {
        path: "client/mgmt/cost/reduction/proposal",
        name: "client_mgmt_cost_reduction_proposal",
        component: CostReductionProposal,
        meta: {
          breadcrumb: [
            {
              name: "CUSTOMERMANAGEMENT",
              link: "/clientprocess",
            },
            { name: "COSTREDUCTIONPROPOSAL" },
          ],
          title: "KANBEI",
          access_key: "client-cost-reduction-proposal-crm-70",
          auth: true,
          admin: true,
        },
      },
      // CRM-72 依頼申込詳細
      {
        path: "client/mgmt/request/app/detail",
        name: "client_mgmt_request_app_detail",
        component: RequestAppDetail,
        meta: {
          breadcrumb: [
            {
              name: "CLIENTPROCESS",
              link: "/clientProcess",
            },
            { name: "REQUESTAPPDETAIL" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-73 顧客管理（入力代行サービス）
      // CRM-77 顧客管理（顧客対応）
      // CRM-92 顧客管理（補助金査定）
      //This is already implememted in clientProcess , so commenting this route
      // {
      //   path: "client/mgmt",
      //   name: "client_mgmt_index",
      //   component: ClientMgmt,
      //   meta: {
      //     breadcrumb: [{ name: "CUSTOMERMANAGEMENT" }],
      //     title: "KANBEI",
      //     userAuth: true,
      //   },
      // },
      // CRM-76 契約情報登録・編集
      {
        path: "client/mgmt/contract/info/add/edit",
        name: "client_mgmt_contract_info_add_edit",
        component: ContractInfoAddEdit,
        meta: {
          breadcrumb: [
            {
              name: "CUSTOMERMANAGEMENT",
              link: "/clientProcess",
            },
            { name: "CONTRACTINFORMATIONREGISTRATIONEDIT" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-78 顧客対応追加
      {
        path: "client/mgmt/client/transaction/add",
        name: "client_mgmt_client_transaction_add",
        component: ClientTransactionAdd,
        meta: {
          breadcrumb: [
            {
              name: "CUSTOMERMANAGEMENT",
              link: "/clientProcess",
            },
            { name: "ADDCUSTOMERSUPPORT" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-85 費目別評価・判定設定（年）
      {
        path: "master/maintenance/judgement/setting/year",
        name: "master_maintenance_judgement_setting_year",
        component: JudgementSettingYear,
        meta: {
          breadcrumb: [
            {
              name: "MASTERMAINTENANCETITLE",
              link: "/master/maintenance",
            },
            {
              name: "ITEMMASTERMAINTENANCE",
              link: "/mastermaintenance",
            },
            {
              name: "ITEMMASTEREGISTRATIONEDIT",
              link: "/expenseitem/addedit/",
            },
            { name: "JUDGEMENTSETTINGYEAR" },
          ],
          title: "KANBEI",
          access_key: "judgment-setting-year-crm-85",
          auth: true,
          admin: true,
        },
      },

            // CRM-85 費目別評価・判定設定（年）
            {
              path: "master/maintenance/judgement/setting/year_update",
              name: "master_maintenance_judgement_setting_year_update",
              component: JudgementSettingYearUpdate,
              meta: {
                breadcrumb: [
                  {
                    name: "MASTERMAINTENANCETITLE",
                    link: "/master/maintenance",
                  },
                  {
                    name: "ITEMMASTERMAINTENANCE",
                    link: "/mastermaintenance",
                  },
                  {
                    name: "ITEMMASTEREGISTRATIONEDIT",
                    link: "/expenseitem/addedit/",
                  },
                  { name: "JUDGEMENTSETTINGYEAR" },
                ],
                title: "KANBEI",
                access_key: "judgment-setting-year-crm-85",
                auth: true,
                admin: true,
              },
            },
      // CRM-86 費目別評価・判定設定（月）
      {
        path: "master/maintenance/judgement/setting/month",
        name: "master_maintenance_judgement_setting_month",
        component: JudgementSettingMonth,
        meta: {
          breadcrumb: [
            {
              name: "MASTERMAINTENANCETITLE",
              link: "/master/maintenance",
            },
            {
              name: "ITEMMASTERMAINTENANCE",
              link: "/mastermaintenance",
            },
            {
              name: "ITEMMASTEREGISTRATIONEDIT",
              link: "/expenseitem/addedit/",
            },
            { name: "JUDGEMENTSETTINGMONTH" },
          ],
          title: "KANBEI",
          access_key: "judgment-setting-month-crm-86",
          auth: true,
          admin: true,
        },
      },
      // CRM-98 補助金情報編集
      {
        path: "client/mgmt/subsidy/info/edit",
        name: "client_mgmt_subsidy_info_edit",
        component: SubsidyInfoEdit,
        meta: {
          breadcrumb: [
            {
              name: "CUSTOMERMANAGEMENT",
              link: "/clientProcess",
            },
            {
              name: "SUBSIDYASSESSMENTDETAIL",
              link: "/client/mgmt/subsidy/assessment/detail",
            },
            { name: "SUBSIDYASSESSMENTEDIT" },
          ],
          title: "KANBEI",
          access_key: "subsidy-assessment-edit-crm-98",
          auth: true,
          admin: true,
        },
      },
      // CRM-99 補助金査定詳細
      {
        path: "client/mgmt/subsidy/assessment/detail",
        name: "client_mgmt_subsidy_assessment_detail",
        component: SubsidyAssessmentDetail,
        meta: {
          breadcrumb: [
            {
              name: "CUSTOMERMANAGEMENT",
              link: "/clientProcess",
            },
            { name: "SUBSIDYASSESSMENTDETAIL" },
          ],
          title: "KANBEI",
          access_key: "subsidy-assessment-detail-crm-99",
          auth: true,
          admin: true,
        },
      },
      // CRM-92 補助金査定
      {
        path: "client/mgmt/subsidy/assessment",
        name: "client_mgmt_subsidy_assessment",
        component: SubsidyAssessment,
        meta: {
          breadcrumb: [
            {
              name: "CUSTOMERMANAGEMENT",
              link: "/client/list",
            },
            { name: "SUBSIDYASSESSMENTEDIT" },
          ],
          title: "KANBEI",
          access_key: "client-subsidy-assessment-crm-92",
          auth: true,
          admin: true,
        },
      },
      // CRM-15 顧客一覧
      {
        path: "client/lists",
        name: "client_lists",
        component: Clientlists,
        meta: {
          breadcrumb: [{ name: "CLIENTLIST" }],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-40 勘定科目マスタメンテ
      {
        path: "master/maintenance/cost/account/maintenance",
        name: "cost_account_maintenance",
        component: CostAccountMaintenance,
        meta: {
          breadcrumb: [
            {
              name: "MASTERMAINTENANCETITLE",
              link: "/master/maintenance",
            },
            { name: "COSTACCOUNTMAINTENANCE" },
          ],
          title: "KANBEI",
          access_key: "accounts-master-maintenance-crm-40",
          auth: true,
          admin: true,
        },
      },
      // CRM-41 勘定科目マスタ登録・編集
      // CRM-97 勘定科目コード説明(モーダル)
      {
        path: "master/maintenance/cost/account/maintenance/addEdit",
        name: "cost_account_maintenance_addEdit",
        component: CostAccountMaintenanceAddEdit,
        meta: {
          breadcrumb: [
            {
              name: "MASTERMAINTENANCETITLE",
              link: "/master/maintenance",
            },
            {
              name: "COSTACCOUNTMAINTENANCE",
              link: "/master/maintenance/cost/account/maintenance",
            },
            { name: "COSTACCOUNTMAINTENANCEADDEDIT" },
          ],
          title: "KANBEI",
          access_key: "accounts-master-add-edit-crm-41",
          auth: true,
          admin: true,
        },
      },
      // CRM-40 勘定科目マスタメンテ
      {
        path: "master/maintenance/supplier-company",
        name: "supplier_company",
        component: SupplierCompany,
        meta: {
          breadcrumb: [
            {
              name: "MASTERMAINTENANCETITLE",
              link: "/master/maintenance",
            },
            { name: "SUPPLIERCOMPANY" },
          ],
          title: "KANBEI",
          access_key: "accounts-master-maintenance-crm-40",
          auth: true,
          admin: true,
        },
      },
      // CRM-41 勘定科目マスタ登録・編集
      // CRM-97 勘定科目コード説明(モーダル)
      {
        path: "master/maintenance/supplier-company/update",
        name: "supplier_company_update",
        component: SupplierCompanyUpdate,
        meta: {
          breadcrumb: [
            {
              name: "MASTERMAINTENANCETITLE",
              link: "/master/maintenance",
            },
            {
              name: "SUPPLIERCOMPANY",
              link: "/master/maintenance/supplier-company",
            },
            { name: "SUPPLIERCOMPANYUPDATE" },
          ],
          title: "KANBEI",
          access_key: "accounts-master-add-edit-crm-41",
          auth: true,
          admin: true,
        },
      },
      {
        path: "master/maintenance/supplier-company/import",
        name: "supplier_company_import",
        component: SupplierCompanyImport,
        meta: {
          breadcrumb: [
            {
              name: "MASTERMAINTENANCETITLE",
              link: "/master/maintenance",
            },
            {
              name: "SUPPLIERCOMPANY",
              link: "/master/maintenance/supplier-company",
            },
            { name: "SUPPLIERCOMPANYIMPORT" },
          ],
          title: "KANBEI",
          access_key: "accounts-master-add-edit-crm-41",
          auth: true,
          admin: true,
        },
      },
      {
        path: "master/maintenance/journal-format",
        name: "journal_format",
        component: JournalFormat,
        meta: {
          breadcrumb: [
            {
              name: "MASTERMAINTENANCETITLE",
              link: "/master/maintenance",
            },
            { name: "JOURNALFORMAT" },
          ],
          title: "KANBEI",
          access_key: "accounts-master-maintenance-crm-40",
          auth: true,
          admin: true,
        },
      },
      {
        path: "master/maintenance/journal-format/update",
        name: "journal_format_update",
        component: JournalFormatUpdate,
        meta: {
          breadcrumb: [
            {
              name: "MASTERMAINTENANCETITLE",
              link: "/master/maintenance",
            },
            {
              name: "JOURNALFORMAT",
              link: "/master/maintenance/journal_format",
            },
            { name: "JOURNAL_FORMAT_UPDATE" },
          ],
          title: "KANBEI",
          access_key: "accounts-master-add-edit-crm-41",
          auth: true,
          admin: true,
        },
      },
      // CRM-44 仕訳帳インポート
      {
        path: "journal/import",
        name: "journal_import",
        component: JournalImport,
        meta: {
          breadcrumb: [{ name: "JOURNALIMPORT" }],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      //CRM-60
      {
        path: "itemconfirmation",
        name: "item_confirmation",
        component: AccountItemConfirmation,
        meta: {
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-45 仕訳帳取込確認
      // CRM-61 仕訳帳項目選択(モーダル)
      {
        path: "journal/import/extract/confirmation",
        name: "extract_confirmation",
        component: ExtractConfirmation,
        meta: {
          breadcrumb: [
            {
              name: "JOURNALIMPORT",
              link: "/journal/import",
            },
            { name: "JOURNALIMPORTEXTRACTCONFIRMATION" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-46 仕訳帳費目紐付け
      {
        path: "journal/import/cost/item/binding",
        name: "cost_item_binding",
        component: CostItemBinding,
        meta: {
          breadcrumb: [
            {
              name: "JOURNALIMPORT",
              link: "/journal/import",
            },
            { name: "JOURNALIMPORTCOSTITEMBINDING" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-47 ポイントプログラム
      // CRM-48 カテゴリ登録・編集
      // CRM-49 ポイントプログラム登録・編集
      // CRM-50 ポイントプログラム登録編集確認
      // CRM-51 ポイントプログラム登録編集完了
      // CRM-52 統計データルーム
      // CRM-53 サプライヤー別契約一覧
      // CRM-54 費目別契約一覧
      // CRM-56 担当者別契約一覧
      // CRM-57 システムマスタメンテナンス
      // CRM-59 仕訳帳取込完了
      // CRM-47 ポイントプログラム
      {
        path: "point/program",
        name: "point_program",
        component: PointProgramAdmin,
        meta: {
          breadcrumb: [{ name: "POINTPROGRAM" }],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-48 カテゴリ登録・編集
      {
        path: "point/program/category/addEdit",
        name: "point_program_category_addEdit",
        component: CategoryAddEdit,
        meta: {
          breadcrumb: [
            {
              name: "POINTPROGRAM",
              link: "/point/program",
            },
            { name: "CATEGORYADDEDIT" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-49 ポイントプログラム登録・編集
      {
        path: "point/program/addEdit",
        name: "point_program_addEdit",
        component: ProgramAddEdit,
        meta: {
          breadcrumb: [
            {
              name: "POINTPROGRAM",
              link: "/point/program",
            },
            { name: "PROGRAMADDEDIT" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-50 ポイントプログラム登録編集確認
      {
        path: "point/program/addEdit/confirmation",
        name: "point_program_addEdit_confirmation",
        component: ProgramAddEditConfirmation,
        meta: {
          breadcrumb: [
            {
              name: "POINTPROGRAM",
              link: "/point/program",
            },
            { name: "PROGRAMADDEDITCONFIRMATION" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-51 ポイントプログラム登録編集完了
      {
        path: "point/program/addEdit/complete",
        name: "point_program_addEdit_complete",
        component: ProgramAddEditComplete,
        meta: {
          breadcrumb: [
            {
              name: "POINTPROGRAM",
              link: "/point/program",
            },
            { name: "PROGRAMADDEDITCOMPLETE" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-52 統計データルーム
      {
        path: "statistical/data/room",
        name: "statistical_data_room",
        component: StatisticalDataRoom,
        meta: {
          breadcrumb: [{ name: "STATISTICALDATAROOM" }],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-53 サプライヤー別契約一覧
      {
        path: "statistical/data/room/supplier/contract/list",
        name: "supplier_contract_list",
        component: SupplierContractList,
        meta: {
          breadcrumb: [
            {
              name: "STATISTICALDATAROOM",
              link: "/statistical/data/room",
            },
            {
              name: "SUPPLIERACQUISITIONLIST",
              link: "/statistical/data/room/supplier/acquisition/list",
            },
            { name: "SUPPLIERCONTRACTLIST" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-54 費目別契約一覧
      {
        path: "statistical/data/room/cost/item/wise/contract/list",
        name: "cost_item_wise_contract_list",
        component: CostItemWiseContractList,
        meta: {
          breadcrumb: [
            {
              name: "STATISTICALDATAROOM",
              link: "/statistical/data/room",
            },
            {
              name: "COSTITEMCONTRACTLIST",
              link: "/statistical/data/room/cost/item/contract/list",
            },
            { name: "COSTITEMWISECONTRACTLIST" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-56 担当者別契約一覧
      {
        path: "statistical/data/room/person/wise/contract/list",
        name: "person_wise_contract_list",
        component: PersonWiseContractList,
        meta: {
          breadcrumb: [
            {
              name: "STATISTICALDATAROOM",
              link: "/statistical/data/room",
            },
            {
              name: "PERSONCONTRACTLIST",
              link: "/statistical/data/room/person/contract/list",
            },
            { name: "PERSONWISECONTRACTLIST" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-57 システムマスタメンテナンス
      {
        path: "master/maintenance/system/master/maintenance",
        name: "system_master_maintenance",
        component: SystemMasterMaintenance,
        meta: {
          breadcrumb: [
            {
              name: "MASTERMAINTENANCETITLE",
              link: "/master/maintenance",
            },
            { name: "SYSTEMMASTERMAINTENANCE" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-59 仕訳帳取込完了
      {
        path: "journal/import/extract/complete",
        name: "extract_complete",
        component: ExtractComplete,
        meta: {
          breadcrumb: [
            {
              name: "JOURNALIMPORT",
              link: "/journal/import",
            },
            { name: "JOURNALIMPORTEXTRACTCOMPLETE" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-79 業種分類マスタメンテナンス
      {
        path: "master/maintenance/industry/type/maintenance",
        name: "industry_type_maintenance",
        component: IndustryTypeMaintenance,
        meta: {
          breadcrumb: [
            {
              name: "MASTERMAINTENANCETITLE",
              link: "/master/maintenance",
            },
            { name: "INDUSTRYTYPEMAINTENANCE" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-80 契約ステータスマスタメンテナンス
      {
        path: "master/maintenance/contract/status/maintenance",
        name: "contract_status_maintenance",
        component: ContractStatusMaintenance,
        meta: {
          breadcrumb: [
            {
              name: "MASTERMAINTENANCETITLE",
              link: "/master/maintenance",
            },
            { name: "CONTRACTSTATUSMAINTENANCE" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-87 サプライヤー別契約獲得数一覧
      {
        path: "statistical/data/room/supplier/acquisition/list",
        name: "supplier_acquisition_list",
        component: SupplierAcquisitionList,
        meta: {
          breadcrumb: [
            {
              name: "STATISTICALDATAROOM",
              link: "/statistical/data/room",
            },
            { name: "SUPPLIERACQUISITIONLIST" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-88 費目別契約獲得数一覧
      {
        path: "statistical/data/room/cost/item/contract/list",
        name: "cost_item_contract_list",
        component: CostItemContractList,
        meta: {
          breadcrumb: [
            {
              name: "STATISTICALDATAROOM",
              link: "/statistical/data/room",
            },
            { name: "COSTITEMCONTRACTLIST" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-90 担当別契約獲得数一覧
      {
        path: "statistical/data/room/person/contract/list",
        name: "person_contract_list",
        component: PersonContractList,
        meta: {
          breadcrumb: [
            {
              name: "STATISTICALDATAROOM",
              link: "/statistical/data/room",
            },
            { name: "PERSONCONTRACTLIST" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-93 業種分類マスタ登録・編集
      {
        path: "master/maintenance/industry/type/addEdit",
        name: "industry_type_addEdit",
        component: IndustryTypeAddEdit,
        meta: {
          breadcrumb: [
            {
              name: "MASTERMAINTENANCETITLE",
              link: "/master/maintenance",
            },
            { name: "INDUSTRYTYPEADDEDIT" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-94 契約ステータスマスタ登録・編集
      {
        path: "master/maintenance/contract/status/addEdit",
        name: "contract_status_addEdit",
        component: ContractStatusAddEdit,
        meta: {
          breadcrumb: [
            {
              name: "MASTERMAINTENANCETITLE",
              link: "/master/maintenance",
            },
            { name: "CONTRACTSTATUSADDEDIT" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-95 カテゴリ登録編集確認
      {
        path: "point/program/category/addEdit/confirmation",
        name: "point_program_category_addEdit_confirmation",
        component: CategoryAddEditConfirmation,
        meta: {
          breadcrumb: [
            {
              name: "POINTPROGRAM",
              link: "/point/program",
            },
            { name: "CATEGORYADDEDITCONFIRMATION" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      // CRM-96 カテゴリ登録編集完了
      {
        path: "point/program/category/addEdit/complete",
        name: "point_program_category_addEdit_complete",
        component: CategoryAddEditComplete,
        meta: {
          breadcrumb: [
            {
              name: "POINTPROGRAM",
              link: "/point/program",
            },
            { name: "CATEGORYADDEDITCOMPLETE" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },

      /**DUPLICATING ROUTER COMPONENTS TO RESOLVE BREADCRUMB ISSUE */
      // CRM-99 補助金査定詳細
      {
        path: "task/subsidy/assessment/detail",
        name: "task_subsidy_assessment_detail",
        component: TaskSubsidyAssessmentDetail,
        meta: {
          breadcrumb: [
            {
              name: "TASKPROCESS",
              link: "/dashboard",
            },
            {
              name: "TASKDETAILSUBSIDY",
              link: "/tasks/subsidydetails/",
            },
            { name: "SUBSIDYASSESSMENTDETAIL" },
          ],
          title: "KANBEI",
          access_key: "subsidy-assessment-detail-crm-99",
          auth: true,
          admin: true,
        },
      },
      {
        path: "agencyInputExpenseItems",
        name: "agency_input_expense_items",
        component: TaskInputExpenseItems,
        meta: {
          breadcrumb: [
            {
              name: "TASKPROCESS",
              link: "/dashboard",
            },
            { name: "TASKDETAILSAGENCY", link: "/tasks/agencydetails" },
            { name: "BYEXPENSEITEM" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
      //CRM-16
      {
        path: "taskClientProcess",
        name: "task_client_process",
        component: TaskClientProcess,
        meta: {
          breadcrumb: [
            { name: "TASKPROCESS", link: "/dashboard" },
            { name: "TASKDETAILS", link: "/tasks/details" },
            { name: "CLIENTPROCESS" },
          ],
          title: "KANBEI",
          auth: true,
          admin: true,
        },
      },
    ],
  },
];
// eslint-disable-next-line no-unused-vars
const userRoutes = [
  { path: "/404", component: NotFound },
  { path: "*", redirect: "/404" },
  { path: "/", redirect: { name: "user_login" } },
  {
    path: "/login",
    name: "user_login",
    component: UserLogin,
    meta: { breadcrumb: "SCHEDULE", title: "KANBEI" },
  },
  {
    path: "/reset/password/request",
    name: "user_reset_password_request",
    component: UserResetPasswordRequest,
    meta: { breadcrumb: "SCHEDULE", title: "KANBEI" },
  },
  {
    path: "/reset/password/:token",
    name: "user_reset_password",
    component: UserResetPassword,
    meta: { breadcrumb: "SCHEDULE", title: "KANBEI" },
  },

  {
    path: "/",
    component: DefaultContainer,
    children: [
      {
        path: "termsandconditions",
        name: "terms_of_service",
        component: TermsOfService,
        meta: {
          title: "KANBEI",
        },
      },
      {
        path: "qna",
        name: "q_and_a",
        component: QAndA,
        meta: {
          title: "KANBEI",
        },
      },
      {
        path: "contact",
        name: "inquiry",
        component: Inquiry,
        meta: {
          title: "KANBEI",
        },
      },
      {
        path: "privacy_policy",
        name: "privacyPolicy",
        component: PrivacyPolicy,
        meta: {
          title: "KANBEI",
        },
      },
      {
        path: "contact/complete",
        name: "contact_complete",
        component: InquiryCompleted,
        meta: {
          title: "KANBEI",
        },
      },
    ],
  },
  {
    path: "/",
    component: RootSidebarContainer,
    children: [
      {
        path: "dashboard",
        name: "user_dashboard",
        component: UserDashboard,
        meta: {
          breadcrumb: [{ name: "DASHBOARDBREADCRUMB" }],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      {
        path: "improvement/expense",
        name: "improvement_expense",
        component: ImprovementExpense,
        meta: {
          breadcrumb: [{ name: "IMPROVEMENTCHART" }],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      {
        path: "improvement/expense/judgement",
        name: "improvement_expense_judgement",
        component: ImprovementExpenseMonth,
        meta: {
          breadcrumb: [{ name: "IMPROVEMENTCHART" }],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      {
        path: "reduction/proposal",
        name: "user_reduction_proposal",
        component: ReductionProposal,
        meta: {
          breadcrumb: [{ name: "LISTOFNOTICES" }],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      {
        path: "reduction/proposal/message",
        name: "proposal_message",
        component: ProposalMessage,
        meta: {
          breadcrumb: [
            {
              name: "REDUCTIONPROPOSALMESSAGE",
            },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      {
        path: "expense/item",
        name: "input_expense_item",
        component: InputExpenseItem,
        meta: {
          breadcrumb: [{ name: "BYEXPENSEITEM", link: "expense/item" }],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      {
        path: "yearly/expense/details",
        name: "yearly_expense_details",
        component: YearlyExpenseDetails,
        meta: {
          breadcrumb: [
            { name: "CHANGEBYEXPENSEITEM" },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      {
        path: "expense/details/confirmation",
        name: "expense_details_confirmation",
        component: ExpenseConfirmation,
        meta: {
          breadcrumb: [
            { name: "REDUCTIONPROPOSALMENU" },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      {
        path: "expense/evaluation",
        name: "expense_evaluation",
        component: ExpenseEvaluationList,
        meta: {
          breadcrumb: [{ name: "LISTOFEXPENSEEVALUATION" }],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      {
        path: "monthly/evaluation/details",
        name: "monthly_expense_details",
        component: MonthlyExpenseDetails,
        meta: {
          breadcrumb: [
            { name: "CHANGEBYEXPENSEITEM" },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      {
        path: "expense/evaluation/details/preview",
        name: "reduction_proposal_preview",
        component: ReductionProposalPreview,
        meta: {
          breadcrumb: [
            { name: "REDUCTIONPROPOSALMENU" },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      //CRF-60
      {
        path: "itemconfirmation",
        name: "item_confirmation",
        component: AccountItemConfirmation,
        meta: {
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      {
        path: "service/request",
        name: "agency_service_request",
        component: AgencyServiceRequest,
        meta: {
          breadcrumb: [
            {
              name: "AGENCYSERVICEREQUEST",
            },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      {
        path: "edit/settings",
        name: "edit_settings",
        component: Settings,
        meta: {
          breadcrumb: [{ name: "SETTINGSSCREEN" }],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      // 仕訳帳インポート CRF-38
      {
        path: "journal/import",
        name: "journal_import",
        component: JournalImport,
        meta: {
          breadcrumb: [{ name: "JOURNALIMPORT" }],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      // 仕訳帳項目確認 CRF-47
      {
        path: "journal/import/item/confirmation/:file_no?",
        name: "journal_import_item_confirmation",
        component: ItemConfirmation,
        meta: {
          breadcrumb: [
            { name: "JOURNALIMPORTITEMCONFIRMATION" },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      // 仕訳帳取込確認 - CRF-40
      {
        path: "journal/import/extract/confirmation",
        name: "extract_confirmation",
        component: ExtractConfirmation,
        meta: {
          breadcrumb: [
            { name: "JOURNALIMPORTEXTRACTCONFIRMATION" },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      // 仕訳帳費目紐付け CRF-41
      {
        path: "journal/import/cost/item/binding",
        name: "cost_item_binding",
        component: CostItemBinding,
        meta: {
          breadcrumb: [
            { name: "JOURNALIMPORTCOSTITEMBINDING" },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      // 仕訳帳取込完了 CRF-46
      {
        path: "journal/import/extract/complete",
        name: "extract_complete",
        component: ExtractComplete,
        meta: {
          breadcrumb: [
            { name: "JOURNALIMPORTEXTRACTCOMPLETE" },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      // FREEEAPIアクセストークン取得 CRF-53
      {
        path: "journal/import/freeAPI/accesstoken/fetch",
        name: "freeAPI_accesstoken_fetch",
        component: FreeAPIAccesstokenFetch,
        meta: {
          breadcrumb: [
            { name: "JOURNALIMPORTFREEAPIACCESSTOKENFETCH" },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      // 仕訳帳ファイルダウンロード CRF-54
      {
        path: "journal/import/file/download",
        name: "file_download",
        component: FileDownload,
        meta: {
          breadcrumb: [
            { name: "JOURNALIMPORTFILEDOWNLOAD" },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      // 仕訳帳ファイルダウンロード完了 CRF-55
      {
        path: "journal/import/file/download/complete",
        name: "file_download_complete",
        component: FileDownloadComplete,
        meta: {
          breadcrumb: [
            { name: "JOURNALIMPORTFILEDOWNLOADCOMPLETE" },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      // 補助金・助成金交付判定 CRF-33
      {
        path: "subsidy/grant/judgement/index",
        name: "subsidy_grant_judgement_index",
        component: SubsidyGrantJudgement,
        meta: {
          breadcrumb: [{ name: "SUBSIDYGRANTJUDGEMENT" }],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      // 判定チャート CRF-34
      {
        path: "subsidy/grant/judgement/chart",
        name: "subsidyGrantJudgement_chart",
        component: JudgementChart,
        meta: {
          breadcrumb: [
            { name: "SUBSIDYGRANTJUDGEMENTCHART" },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      // 判定結果 CRF-35
      {
        path: "subsidy/grant/judgement/result",
        name: "subsidyGrantJudgement_result",
        component: JudgementResult,
        meta: {
          breadcrumb: [
            { name: "SUBSIDYGRANTJUDGEMENTRESULT" },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      // 補助金・助成金申請確認 CRF-36
      {
        path: "subsidy/app/confirmation",
        name: "subsidy_app_confirmation",
        component: SubsidyAppConfirmation,
        meta: {
          breadcrumb: [{ name: "SUBSIDYAPPCONFIRMATION" }],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      // 補助金・助成金申請完了 CRF-37
      {
        path: "subsidy/app/complete",
        name: "subsidy_app_complete",
        component: SubsidyAppComplete,
        meta: {
          breadcrumb: [{ name: "SUBSIDYAPPCOMPLETE" }],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      // CRF-56 選択内容確認
      {
        path: "subsidy/grant/judgement/content/confirmation",
        name: "subsidy_grant_judgement_content_confirmation",
        component: ContentConfirmation,
        meta: {
          breadcrumb: [
            { name: "SELECTCONTENTCONFIRMATION" },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      // CRF-52 補助金査定メッセージ詳細
      {
        path: "notification/subsidy/assess/msg/detail",
        name: "notification_subsidy_assess_msg_detail",
        component: SubsidyAssessMsgDetail,
        meta: {
          breadcrumb: [
            { name: "SUBSIDYASSESSMSGDETAIL" },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      // CRF-42 ポイントプログラム
      {
        path: "point/program",
        name: "point_program",
        component: PointProgram,
        meta: {
          breadcrumb: [{ name: "POINTPROGRAM" }],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      // CRF-43 ポイント獲得・消費履歴
      {
        path: "point/program/history",
        name: "point_program_history",
        component: PointProgramHistory,
        meta: {
          breadcrumb: [
            { name: "POINTPROGRAMHISTORY" },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      // CRF-44 ポイント交換応募確認
      {
        path: "point/program/point/exchange/confirmation",
        name: "point_program_point_exchange_confirmation",
        component: PointProgramPointExchangeConfirmation,
        meta: {
          breadcrumb: [
            { name: "POINTPROGRAMPOINTEXCHANGECONFIRMATION" },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      // CRF-45 ポイント交換応募完了
      {
        path: "point/program/point/exchange/complete",
        name: "point_program_point_exchange_complete",
        component: PointProgramPointExchangeComplete,
        meta: {
          breadcrumb: [
            { name: "POINTPROGRAMPOINTEXCHANGECOMPLETE" },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      // CRF-50 ポイント説明(モーダル)
      // CRF-51 ポイント交換応募一覧
      {
        path: "point/program/point/exchange/app/list",
        name: "point_program_point_exchange_app_list",
        component: PointProgramPointExchangeAppList,
        meta: {
          breadcrumb: [
            { name: "POINTPROGRAMPOINTEXCHANGEAPPLIST" },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      /**duplicating BIZ routing Components for Breadcrumb */
      {
        path: "expense/item",
        name: "user_input_expense_item",
        component: UserInputExpenseItem,
        meta: {
          breadcrumb: [
            { name: "BYEXPENSEITEM" },
          ],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
      {
        path: "faq",
        name: "faq",
        component: FAQ,
        meta: {
          breadcrumb: [{ name: "FAQ" }],
          title: "KANBEI",
          auth: true,
          user: true,
        },
      },
    ],
  },
];
/**
 * Client build(for Domain)
 * const baseUrl =  "/",
 *
 * NIS test build
 * const baseUrl = "/";
 */

/**Please enable below two lines while generating business build */
const baseUrl = "/";
let routes = userRoutes;

/**Please enable below two lines while generating admin build */
// const baseUrl = "/mng/";
// let routes = adminRoutes;

const router = new Router({
  /* toggle below two lines if  you want to remove # symbol and redired admin route to admin login */
  mode: "history",
  base: baseUrl,
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: routes,
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  /** auth guards */
  if (to.meta.auth == true) {
    if (!localStorage.getItem("token")) {
      next("/login");
    } else {
      if (to.meta.user == true && localStorage.getItem("role") == "ADMIN") {
        next("/login"); // go to 'admin/login';
      }
      if (to.meta.admin == true && localStorage.getItem("role") == "USER") {
        next("/login"); // go to 'user/login';
      }
    }
  }
  if (to.meta.access_key) {
    const rule = checkAccessControl(to.meta.access_key);
    if (!rule) {
      return next({ name: "admin_login" });
    }
  }
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  let removedElements = Array.from(
    document.querySelectorAll("[data-vue-router-controlled]")
  ).map((el) => el.parentNode.removeChild(el));
  logValuesInSession("removedElements", removedElements);
  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag));

  next();
});
export default router;
